/** In-app logo (header / sidebar). PWA icons live in /icons/. */
export const APP_LOGO_SRC = `${process.env.PUBLIC_URL}/images/logo/Logo.png`;
